(() => {
  if (customElements.get('octulos-timeline')) return;
  customElements.define('octulos-timeline', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.otl__viewport');
      this.previous = this.querySelector('.otl__previous');
      this.next = this.querySelector('.otl__next');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal, passive: true };
      this.update = () => {
        const distance = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const position = this.viewport.scrollLeft;
        this.previous.disabled = position <= 1;
        this.next.disabled = position >= distance - 1;
        this.style.setProperty('--otl-progress', distance ? Math.min(1, Math.max(0, position / distance)) : 1);
      };
      const move = direction => {
        const item = this.querySelector('.otl__item');
        this.viewport.scrollBy({ left: direction * (item?.getBoundingClientRect().width || this.viewport.clientWidth), behavior: this.motion.matches ? 'instant' : 'smooth' });
      };
      this.previous.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.viewport.addEventListener('scroll', this.update, options);
      // Follow document scrolling without consuming wheel or touch events.
      this.followPage = () => {
        if (this.motion.matches) return;
        const bounds = this.getBoundingClientRect();
        const startValue = Number(this.dataset.scrollStart ?? 50);
        const endValue = Number(this.dataset.scrollEnd ?? 10);
        const start = Math.max(5, Math.min(100, Number.isFinite(startValue) ? startValue : 50));
        const end = Math.max(0, Math.min(start - 5, Number.isFinite(endValue) ? endValue : 10));
        const position = bounds.top / window.innerHeight * 100;
        const progress = Math.min(1, Math.max(0, (start - position) / (start - end)));
        this.viewport.scrollTo({ left: progress * (this.viewport.scrollWidth - this.viewport.clientWidth), behavior: 'instant' });
      };
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.followPage(); });
      };
      window.addEventListener('scroll', this.schedule, options);
      window.addEventListener('resize', this.schedule, options);
      this.motion.addEventListener('change', this.schedule, options);
      this.schedule();
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.otl__item');
        const first = this.querySelector('.otl__item');
        if (item && first) this.viewport.scrollTo({ left: item.offsetLeft - first.offsetLeft, behavior: 'instant' });
      }, options);
      this.querySelector('.otl__buttons').hidden = false;
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.viewport);
      this.observer.observe(this.querySelector('.otl__track'));
      this.update();
    }
    disconnectedCallback() {
      this.abort.abort();
      this.observer.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
})();

